<!-- App.vue -->
<template>
    <div class="bg-white min-vh-100">
        <CCol sm="12" xs="6" class="text-right">
            <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
    
            </h5>
    
        </CCol>
        <CCol sm="12" class="mt-5">
            <div class="text-center">
                <img class="ml-3" style="max-width:80%" src="../assets/img/miracle.png" />
                <h3 class="custom-20px-600 text-center">Find Your Wishes</h3>
                <p class="custom-12px">“3 wishes remaining for free servicess for you”</p>
    
                <input type="text" placeholder="Type here" class="custom-input-app" />
    
                <CButton type="button" class="button-border-blue text-white mt-4" block>Share now <img class="size16px" src="../assets/img/share.png" /></CButton>
    

                <CButton type="button" class="button-border-blue-white mt-4" block @click="GoToBooking()">Continue</CButton>

                <p class="text-center custom-danger-text mt-3">Share to your friends to keep your free wishes</p>
    
    
    
    
            </div>
    
        </CCol>
    
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            videoStream: null,
            isLanguagePopupVisible: false,
        };
    },
    methods: {
        async startCamera() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.$refs.video.srcObject = stream;
                this.videoStream = stream;
            } catch (error) {
                console.error('Error accessing camera:', error);
            }
        },
        takePicture() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            const context = canvas.getContext('2d');

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // You can now access the image data in the canvas and send it to the server or perform other actions.

            // Stop the video stream to release the camera.
            this.videoStream.getTracks().forEach(track => track.stop());

            this.isLanguagePopupVisible = true;
        },
        GoToSelected() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToBooking()
        {
            this.$router.push("ChooseDate");
        }
    },
};
</script>
  
<style>
/* Add your styles here if needed */
</style>
  